import React, { ReactElement } from 'react';
import { useEffect } from 'react';
import {
  Chart,
  ChartSeries,
  ChartSeriesItem,
  ChartLegend,
  SeriesClickEvent,
  LegendItemClickEvent,
  ChartSeriesLabels,
} from '@progress/kendo-react-charts';
import { Card } from '@progress/kendo-react-layout';
import {
  ExpansionPanel,
  ExpansionPanelContent,
  ExpansionPanelActionEvent,
} from '@progress/kendo-react-layout';
import { Reveal } from '@progress/kendo-react-animation';
import { useHistory } from 'react-router-dom';
import { Loader } from '@progress/kendo-react-indicators';

const OverviewWidgetPieChart: React.FC<{
  chartTitleText: string;
  seriesData: any;
  chartSeriesClick?: (event: SeriesClickEvent) => void;
  legendItemClick?: (event: LegendItemClickEvent) => void;
  chartSeriesField: string;
  chartSeriesCategoryField: string;
  labelContent: (event: any) => string;
  goToScreen: string;
  isRefreshing?: boolean;
}> = ({
  chartTitleText,
  seriesData,
  chartSeriesClick,
  legendItemClick,
  chartSeriesField,
  chartSeriesCategoryField,
  labelContent,
  goToScreen,
  isRefreshing,
}): ReactElement => {
  const history = useHistory();

  const onChartSeriesClick = (event: SeriesClickEvent) => {
    if (chartSeriesClick) {
      chartSeriesClick(event);
    }

    navigate();
  };

  const onLegendItemClick = (event: LegendItemClickEvent) => {
    if (legendItemClick) {
      legendItemClick(event);
    }
  };

  const navigate = () => history.push('/' + goToScreen);

  const [expanded, setExpanded] = React.useState<boolean>(false);

  useEffect(() => {
    setExpanded(seriesData != undefined && seriesData.length > 0);
  }, [seriesData]);

  return (
    <div>
      {isRefreshing ? (
        <div
          style={{
            textAlign: 'center',
          }}
        >
          <Loader size="large" type={'pulsing'} />
        </div>
      ) : (
        <ExpansionPanel
          title={chartTitleText}
          style={{ color: 'red' }}
          expanded={expanded}
          tabIndex={0}
          key={chartTitleText}
          onAction={(event: ExpansionPanelActionEvent) => {
            setExpanded(!expanded);
          }}
        >
          <Reveal>
            {expanded && (
              <ExpansionPanelContent>
                <Card onClick={() => navigate()}>
                  <Chart
                    onSeriesClick={onChartSeriesClick}
                    onLegendItemClick={onLegendItemClick}
                  >
                    <ChartLegend
                      position="bottom"
                      orientation="vertical"
                      align="end"
                    />
                    <ChartSeries>
                      <ChartSeriesItem
                        type="pie"
                        data={seriesData}
                        field={chartSeriesField}
                        categoryField={chartSeriesCategoryField}
                      >
                        <ChartSeriesLabels
                          background="none"
                          content={labelContent}
                        />
                      </ChartSeriesItem>
                    </ChartSeries>
                  </Chart>
                </Card>
              </ExpansionPanelContent>
            )}
          </Reveal>
        </ExpansionPanel>
      )}
    </div>
  );
};

export default OverviewWidgetPieChart;
